<template>
    <v-dialog
        class="seach-popup"
        v-model="dialog"
        persistent
        overlay-opacity="0.2"
        :width="`${dialogWidth}px`"
        @click:outside="closeDialog"
    >
        <v-card class="pt-4 pb-8">
            <div class="d-flex justify-end mb-1 px-6 font-weight-bold">
                <v-icon
                    @click.prevent="closeDialog"
                    x-small
                    color="black"
                >
                    icon-close
                </v-icon>
            </div>
            <div class="d-flex justify-center mb-4">
                <div class="pa-11 circle rounded-circle d-inline-block">
                    <v-img
                        :src="glassImg"
                        :max-width="88"
                        class="loupe"
                    />
                </div>
            </div>
            <div class="d-flex justify-center mb-2">
                <h2 class="text-center font-weight-bold">
                    {{ $t('searchPopup.title') }}
                </h2>
            </div>

            <div class="d-flex justify-center mb-6">
                <span class="text-center">
                    {{ lotView === 'both' ? $t('searchPopup.body2') : $t('searchPopup.body') }}
                </span>
            </div>
            <div
                class="d-flex"
                :class="{
                    'mobile': $vuetify.breakpoint.xs,
                    'justify-space-around': $vuetify.breakpoint.smAndDown,
                    'justify-center': $vuetify.breakpoint.mdAndUp
                }"
            >
                <TextButton
                    v-if="lotView ==='both' && hasAlternativePlot"
                    :text="$t('searchPopup.similarPlots')"
                    :isSmall="$vuetify.breakpoint.smAndDown"
                    :isMedium="$vuetify.breakpoint.mdAndUp"
                    @manage-click="switchWidget"
                />
                <TextButton
                    :text="$t('searchPopup.modifyFilters')"
                    :isSmall="$vuetify.breakpoint.smAndDown"
                    :isMedium="$vuetify.breakpoint.mdAndUp"
                    @manage-click="openSidebar"
                />
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { mapGetters } from "vuex";

    import TextButton from "@/components/searchPopup/components/TextButton";

    export default {
        name: "SearchPopup",
        components: {
            TextButton
        },
        props: {
            widget: {
                type: String,
                required: true
            },
            isOpenedSidebar: {
                type: Boolean,
                required: true
            },
            lotView: {
                type: String,
                required: true
            },
            hasAlternativePlot: {
                type: Boolean,
                required: true
            }
        },
        data: () => ({
            widgetType: null,
            glassImg: require('@/assets/images/glass.png'),
            dialog: true
        }),
        created() {
            this.widgetType = this.$props.widget;
        },
        computed: {
            ...mapGetters([
                'protocol'
            ]),
            dialogWidth() {
                return this.$vuetify.breakpoint.smAndDown ? 288 : 444;
            }
        },
        methods: {
            openSidebar() {
                if (!this.isOpenedSidebar)
                    EventBus.$emit('toggleSidebar');
                this.closeDialog();
            },
            closeDialog() {
                this.$emit('close-dialog');
            },
            switchWidget() {
                this.widgetType = this.$props.widget === 'plot-grid' ? 'cutaway' : 'plot-grid';
                EventBus.$emit('updateLoadedWidgets', {
                    id: this.widgetType,
                    link: 'https://' + process.env.ROOT_API  + '/request-data/cutaway-view' + window.location.search,
                    active: true,
                    widgetType: this.widgetType
                });
                EventBus.$emit('switchSidebar', this.widgetType);
                this.closeDialog();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/searchPopup/SearchPopup.vue